import { connect } from 'react-redux';
import { StartChannelPageComponent } from 'pages/administration.page';
import { isLoadingSelector, startChannelsSelector } from 'common/selectors';
import { setStartChannelsAction, updateStartChannelsAction } from 'common/actions/settings';

export const StartChannelPage = connect(
  (state) => ({
    isLoading: isLoadingSelector(state),
    startChannels: startChannelsSelector(state),
  }),
  (dispatch) => ({
    updateStartChannels: (startChannels) => dispatch(updateStartChannelsAction(startChannels)),
    updateState: (startChannels) => dispatch(setStartChannelsAction(startChannels)),
  })
)(StartChannelPageComponent);
